import React from "react";
export default function Collaborate(){
    return <div className={'p-4 d-flex flex-column justify-content-start align-items-start'}>
        {/* <img src={'./404.png'} alt=""/> */}
        <h1 className={'pl-5 pr-5'}>همکاری با ما
</h1>
        <p className={'pl-5 pr-5'}>تیم نرم افزاری مشاوران تحصیلی با کمال میل و با آغوش باز پذیرای کارشناسان و متخصصان در حوزه های زیر می باشد</p>
    <p className={'pl-5 pr-5'}>متخصصان تحلیل داده</p>
    <p className={'pl-5 pr-5'}>متخصصان طراحی رابط کاربری و گرافیکی</p>
    <p className={'pl-5 pr-5'}>متخصصان طراحی رابط کاربری و گرافیکی</p>
    <p className={'pl-5 pr-5'}>متخصصان حوزه مشاوره تحصیلی با توامندی در تست نرم افزار، ایرادیابی و ارائه راه حل و دستورالعمل دررفع خطاهای منطقی خروجی های آماری</p>
    <p className={'pl-5 pr-5'}>متخصصان حوزه بازاریابی با رزومه بازاریابی دیجیتال و شبکه های مجازی</p>
    <p className={'pl-5 pr-5'}>جهت ارتباط با ما فرم زیر را پر کنید تا در اولین فرصت جهت هماهنگی برای مصاحبه و آشنایی با تیم نرم افزاری مشاوران تحصیلی با شما تماس گرفته شود</p>

    </div>
}